import { render, staticRenderFns } from "./AdminBrandLogo.vue?vue&type=template&id=261258c2&scoped=true&"
import script from "./AdminBrandLogo.vue?vue&type=script&lang=js&"
export * from "./AdminBrandLogo.vue?vue&type=script&lang=js&"
import style0 from "./AdminBrandLogo.vue?vue&type=style&index=0&id=261258c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261258c2",
  null
  
)

export default component.exports